<template>
    <div class="d-flex"
        @drag="preventEvent"
        @dragstart="preventEvent"
        @dragend="preventEvent"
        @dragover="preventEvent"
        @dragenter="preventEvent"
        @dragleave="preventEvent"
        @drop="preventEvent">
        <div class="image-container" v-if="!disabled && !image.path">
            <div class="image-select-wrapper d-flex flex-fill align-items-center justify-content-center">
                <div class="image-drag-drop-cover" v-if="isDragover" @drop="onDrop">
                    <div class="icon-drag-drop center">
                        <img :src="assetsPathTheme('/icons/drag-drop.svg')" />
                    </div>
                </div>
                <div v-else class="image-drag-wrapper" @dragover="onDragover">
                    <div class="icon-drag">
                        <img :src="assetsPathTheme('/icons/image.svg')" />
                    </div>
                    <div class="image-input">
                        <label :for="idUpload" :class="{'cursor-pointer': !disabled}">
                        </label>
                    </div>
                    <div class="text-center" v-if="idUpload == 'image-upload-1' && showImageLimitMessage">
                        <p>
                            <span>Adicionar Images</span><br />
                            Pode adicionar até {{ maxImage }} image{{ maxImage == 1 ? '' : 's' }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="image-container" v-if="image.path">
            <div class="image-preview-wrapper d-flex flex-fill align-items-center justify-content-center cursor-pointer"
                @click.prevent="">
                <div class="show-image lightbox"
                    :class="imageClass"
                    :style="{ 'background-image': `url(${image.path})` }">
                    <div class="image-overlay" :class="{'no-overlay': noOverlay}">
                        <div class="image-overlay-edit" @click.prevent="triggerFileUpdate()" v-if="showEditButton">
                            <div class="icon-overlay text-center">
                                <i class="fas fa-pencil-alt"></i>
                            </div>
                        </div>
                        <div class="image-overlay-exclude" @click.prevent="removeImage()" v-if="showDeleteButton">
                            <div class="icon-overlay text-center">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </div>
                        <div class="image-overlay-details w-100" @click="() => showLightbox()">
                            <div class="icon-overlay text-center">
                                <i class="fas fa-search"></i>
                            </div>
                            <!-- <svg class="icon-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path d="M283.9 186.4h-64.6l-.4-71.1c-.1-8.8-7.2-15.9-16-15.9h-.1c-8.8.1-16 7.3-15.9 16.1l.4 70.9h-64.4c-8.8 0-16 7.2-16 16s7.2 16 16 16h64.6l.4 71.1c.1 8.8 7.2 15.9 16 15.9h.1c8.8-.1 16-7.3 15.9-16.1l-.4-70.9h64.4c8.8 0 16-7.2 16-16s-7.1-16-16-16z"></path>
                                <path d="M511.3 465.3L371.2 325.2c-1-1-2.6-1-3.6 0l-11.5 11.5c31.6-35.9 50.8-82.9 50.8-134.3C406.9 90.3 315.6-1 203.4-1 91.3-1 0 90.3 0 202.4s91.3 203.4 203.4 203.4c51.4 0 98.5-19.2 134.3-50.8l-11.5 11.5c-1 1-1 2.6 0 3.6l140.1 140.1c1 1 2.6 1 3.6 0l41.4-41.4c.9-.9.9-2.5 0-3.5zm-307.9-92.5C109.5 372.8 33 296.4 33 202.4S109.5 32.1 203.4 32.1s170.4 76.4 170.4 170.4-76.4 170.3-170.4 170.3z"></path>
                            </svg> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="image-list-container d-flex align-items-center" v-if="!!image.path && multiple && false">
            <div class="image-list-item" @click.prevent="">
                <div class="">
                    <img class="img-responsive" :src="image.path">
                </div>
            </div>
            <div class="image-list-item">
                <svg class="icon add-image-svg" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
                    <path d="M511.5 227.5h-227V.5h-57v227H-.5v57h228v228h57v-228h227z"></path>
                </svg>
                <div class="input-add-image">
                    <label :for="idUpload" class="">
                    </label>
                </div>
            </div>
        </div>
        <div class="d-none" v-if="!disabled">
            <label :for="idUpload" ref="addImage" class=""></label>
            <input
                ref="uploadFile"
                :id="idUpload"
                name="images"
                type="file"
                class=""
                @change="uploadFieldChange"
                :multiple="multiple"
                :accept="accept"
                >
        </div>
    </div>
</template>
<script>
import GlobalMixin from '@/app/shared/mixins/global';
// :[captureKey]="captureMediaAttribute"

export default {
    name: 'ImageContainer',
    mixins: [
        GlobalMixin
    ],
    props: {
        dragText: {
            type: String,
            default: 'Arrastar imagem'
        },
        browseText: {
            type: String,
            default: '(ou) Selecione'
        },
        primaryText: {
            type: String,
            default: 'Padrão'
        },
        markIsPrimaryText: {
            type: String,
            default: 'Definir como padrão'
        },
        popupText: {
            type: String,
            default: 'Esta imagem será exibida como padrão'
        },
        dropText: {
            type: String,
            default: 'Solte seus arquivos aqui ...'
        },
        accept: {
            type: String,
            default: 'image/gif,image/jpeg,image/png,image/bmp,image/jpg'
        },
        value: {
            default: () => {
                return []
            }
        },
        dataImages: {
            type: Array,
            default: () => {
                return []
            }
        },
        imageList: {
            type: Array,
            default: () => {
                return []
            }
        },
        imageClass: {
            type: String,
            default: 'background-cover'
        },
        multiple: {
            type: Boolean,
            default: true
        },
        showPrimary: {
            type: Boolean,
            default: true
        },
        maxImage: {
            type: Number,
            default: 5
        },
        idUpload: {
            type: String,
            default: 'image-upload'
        },
        idEdit: {
            type: String,
            default: 'image-edit'
        },
        noOverlay: {
            type: Boolean,
            default: false,
        },
        targetImage: {
            type: Object,
            default: () => {
                return {}
            }
        },
        showDeleteButton: {
            type: Boolean,
            default: true
        },
        showEditButton: {
            type: Boolean,
            default: true
        },
        showImageLimitMessage: {
            type: Boolean,
            default: false
        },
        imageIndex: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        capture: {
            type: String,
            default: '',
            validator: function (prop) {
                let valid = [
                    'capture', //the camera app
                    'user', // The user-facing camera and/or microphone should be used.
                    'environment', // The outward-facing camera and/or microphone should be used
                ];
                return !prop || prop && valid.includes(prop);
            }
        },
    },
    data() {
        return {
            currentIndexImage: 0,
            images: [],
            image: {},
            isDragover: false,
            update: false,
            captureMediaAttribute: '',
        }
    },
    computed: {
        // captureKey(){
        //     return !!this.captureMediaAttribute ? 'capture' : 'data-capture';
        // },
        imagePreview() {
            return this.image != {} ? this.image.path : '';
        },
        imageDefault() {
            if (this.image) {
                return this.image.default;
            }
        },
        /* activeEditButton(){
            return this.showEditButton && !this.disabled;
        },
        activeDeleteButton(){
            return this.showDeleteButton && !this.disabled;
        }, */
    },
    methods: {
        showLightbox() {
            this.$emit('show-lightbox', this.imageIndex);
        },
        copyValue (value) {
            if(this.targetImage.path) {
                this.image = this.targetImage;
            } else {
                this.image = value;
            }
        },
        preventEvent(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        onDrop(e) {
            this.isDragover = false;
            this.preventEvent(e);

            let files = e.dataTransfer.files;
            if (!files.length) {
                return false;
            }

            this.imageLimit();

            this.addFiles(files);
        },
        onDragover() {
            this.isDragover = true;
        },
        addFiles(files) {
            if (!this.checkNumberOfImages(files.length)) {
                return false;
            }
            // process all File objects
            for (let i = 0, len = files.length; i < len; i++) {
                const file = files[i];
                if(this.image.path) {
                    this.$emit('update-image', file, this.imageIndex);
                } else {
                    this.$emit('create-image', file);
                }
                if (!this.multiple) {
                    break;
                }
                // process image files under 300,000 bytes
                // if (file.type.indexOf("image") == 0 && file.size < 300000) {
                // ...
                // }
            }
            if (document.getElementById(this.idUpload)) {
                document.getElementById(this.idUpload).value = [];
            }
        },
        uploadFieldChange(e) {
            // File input fields return a FileList via a files property (event.target.files).
            // Dropped files return a FileList object via the event’s dataTransfer.files property (event.dataTransfer.files).
            // fetch FileList object
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return false;
            }
            this.imageLimit();
            this.addFiles(files);
        },
        checkNumberOfImages(amount) {
            if (!this.multiple) {
                return true;
            }
            // if ((amount + this.images.length) > this.maxImage) {
            if (amount > this.maxImage) {
                this.$emit('limit-exceeded', amount);
                return false;
            } else {
                return true;
            }
        },
        // triggerFileInput: function() {
        //     if (this.$refs.addImage && this.imageLimit()) {
        //         this.$refs.addImage.click();
        //     }
        // },
        callFileEvent: function(capture = undefined) {
            this.captureMediaAttribute = capture === undefined ? this.capture : capture;
            this.$nextTick( ()=> {
                this.triggerFileUpdate();
            });
        },
        triggerFileUpdate: function() {
            if (!this.disabled && this.$refs.addImage) {
                this.update = true;
                this.$refs.addImage.click();
            }
        },
        removeImage() {
            if(!this.disabled){
                this.image = {};
                this.$emit('remove-image', this.imageIndex);
            }
        },
        imageLimit: function() {
            if (this.images.length >= this.maxImage && !this.update) {
                this.$root.$helper.messages.showToast('Limite de images excedido!', 'Erro', 'error');
                return false;
            }

            return true;
        },
        setCaptureAttribute: function() {
            let ref = this.$refs['uploadFile'];
            if(ref) {
                let value = this.captureMediaAttribute;
                let key = 'capture';
                if(value){
                    ref.setAttribute(key, value);
                }else{
                    ref.removeAttribute(key);
                }
            }
        },
    },
    mounted() {
        this.captureMediaAttribute = this.capture,
        document.body.addEventListener('dragleave', (evt) => {
            evt.stopPropagation();
            evt.preventDefault();
            this.isDragover = false;
        })
    },
    created() {
        this.image = {};
        this.image = this.targetImage;
        this.images = [];
        this.images = this.imageList;
    },
    beforeMount() {
      // Here we are following the Vue2 convention on custom v-model:
      // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
      this.copyValue(this.value)
    },
    watch: {
        captureMediaAttribute: {
            immediate: true,
            handler(newValue, oldValue){
                this.setCaptureAttribute();
            }
        },
        targetImage: function(newVal) {
            this.image = this.targetImage;
        },
        value (newValue) {
            // This watch works from the code side of the 2-way-binding:
            if(!this.targetImage.path) {
                this.copyValue(newValue);
            }
        }
    },

}
</script>

<style scoped lang="scss">
@import '@styles/_theme.scss';

input[type="file"] {
    position: absolute;
    opacity: 0;
    z-index: -1;
}

.image-container {
    flex: 1;
    position: relative;
    //height: 100%;

    >div {
        flex-grow: 3;
        width: 100%;
        height: 100%;
    }

    .image-select-wrapper {
        border: 2px dashed #ccc;
        background-color: #f6f6f6;
        border-radius: $occurrence-photo-border-radius-1;
        opacity: 0.4;

        .image-drag-drop-cover {
            width: 100%;
            height: 100%;

            .icon-drag-drop > img {
                height: 25px;
                width: 25px;
                @include sm {
                    height: 50px;
                    width: 50px;
                }
            }
        }

        .image-drag-wrapper {
            .icon-drag {
                margin: 0 auto;
                height: 25px;
                width: 25px;
                @include sm {
                    height: 50px;
                    width: 50px;
                }

                > img {
                    margin: 0 auto;
                    height: 25px;
                    width: 25px;
                    @include sm {
                        height: 50px;
                        width: 50px;
                    }
                }
            }

            div p {
                font-size: 1rem;
                > span {
                    color: $secondary-color;
                    font-size: 1.25rem;
                    font-weight: bold;
                }
            }

            .image-input {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                overflow: hidden;
                opacity: 0;

            }

            .image-input label {
                display: block;
                // cursor: pointer;
                width: 100%;
                height: 100%;
            }
        }
    }

    .image-preview-wrapper {
        // cursor: pointer;

        .image-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 10;
            background: rgba(0, 0, 0, .7);
            opacity: 0;
            transition: opacity .3s ease-in-out 0s;
            border-radius: $occurrence-photo-border-radius-2;

            @media (min-width: 576px) {
                border-radius: $occurrence-photo-border-radius-1;
            }

            .image-overlay-details {
                position: absolute;
                z-index: 11;
                opacity: 0;
                transform: translate(0, -50%);
                top: 50%;
                text-align: center;
            }

            .image-overlay-exclude {
                position: absolute;
                z-index: 22;
                opacity: 0;
                transform: translate(0, -50%);
                text-align: center;
                top: 1rem;
                right: 5px;

                @include sm {
                    top: 0;
                    right: 0;
                    margin-top: calc(0px + 20px);
                    margin-right: calc(0px + 10px);
                }
            }

            .image-overlay-edit {
                position: absolute;
                z-index: 22;
                opacity: 0;
                transform: translate(0, -50%);
                text-align: center;
                top: 1rem;
                left: 5px;

                @include sm {
                    top: 0;
                    left: 0;
                    margin-top: calc(0px + 20px);
                    margin-left: calc(0px + 10px);
                }
            }

            .icon-overlay > i {
                color: #fff;

                // width: 20px;
                // height: 20px;
                font-size: 1rem;

                @include sm {
                    // max-width: 40px;
                    // max-height: 40px;
                    // width: 30%;
                    // height: 30%;
                    // font-size: 1.5rem;
                }
            }

            .image-overlay-details {
                .icon-overlay > i {
                    @include sm {
                        font-size: 1.5rem;
                    }
                }
            }

            &.no-overlay {
                cursor: default;
            }

            &:not(.no-overlay):hover {
                opacity: 1;

                .image-overlay-details {
                    opacity: 1;
                }

                .image-overlay-exclude {
                    opacity: 1;
                }

                .image-overlay-edit {
                    opacity: 1;
                }
            }
        }

        .show-image {
            position: relative;
            width: 100%;
            height: 100%;
            border-radius: $occurrence-photo-border-radius-2;
            background-repeat: no-repeat;
            background-position: center;
            &.background-cover {
                background-size: cover;
            }
            &.background-contain {
                background-size: contain;
            }

            @media (min-width: 576px) {
                border-radius: $occurrence-photo-border-radius-1;
            }

            img {
                border-radius: $occurrence-photo-border-radius-2;
                max-height: 425px;

                @media (min-width: 576px) {
                    max-height: 100%;
                    border-radius: $occurrence-photo-border-radius-1;
                }
            }
        }

        // &:hover .image-overlay,
        // &:hover .image-overlay-details{
        //     opacity: 1;
        // }
    }
}

.center {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
</style>